import { Link } from "react-router-dom";
import { Card, EmptyState } from "../components/ui";

export function SoftwareContractsPage() {
  return (
    <div className="page-stack">
      <Card
        title="Contratos de software"
        description="Módulo independente para licenças, assinaturas e serviços de software."
      >
        <EmptyState
          title="Nenhum contrato de software cadastrado"
          description="Os contratos deste módulo usam o núcleo de contratos e recebíveis da EVA Flow. A contratação e a cobrança dependem da configuração comercial do parceiro."
        />
        <Link className="text-link" to="/contratos">
          Ver carteira de contratos
        </Link>
      </Card>
    </div>
  );
}
